import { render, staticRenderFns } from "./PrivateContractsForVehicleWidget.vue?vue&type=template&id=b1dce216&scoped=true&"
import script from "./PrivateContractsForVehicleWidget.vue?vue&type=script&lang=js&"
export * from "./PrivateContractsForVehicleWidget.vue?vue&type=script&lang=js&"
import style0 from "./PrivateContractsForVehicleWidget.vue?vue&type=style&index=0&id=b1dce216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1dce216",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1dce216')) {
      api.createRecord('b1dce216', component.options)
    } else {
      api.reload('b1dce216', component.options)
    }
    module.hot.accept("./PrivateContractsForVehicleWidget.vue?vue&type=template&id=b1dce216&scoped=true&", function () {
      api.rerender('b1dce216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/PrivateContractsForVehicleWidget.vue"
export default component.exports